export default "__VITE_ASSET__0bc0bb8a__"